import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { formatPrice, formatePriceFn } from '../../../helper/commonFunction';
import { getActiveCode } from '../../../helper/currencyState';
import AedChargeNote from '../../../component/AedChargeNote';
import { ChevronUpIcon, ChevronDownIcon, DiscountIcon, CloseIcon, VoucherIcon, SeatIcon, ChevronLeftIcon, ChevronRightIcon, ComputerIcon, WalletIcon } from '../../../helper/HwIcon';
import CommonPopup from '../../common-popup/CommonPopup';
import './flight.css';

const BookingDetailsSideBarComponent = ({
    currentTab,
    flightDataPriceObj,
    agentActiveCurrency,
    setShowTaxAndFees,
    showTaxAndFees,
    activeCouponCodeData,
    showDiscounts,
    extraChargePrice,
    setExtraChargePrice,
    finalAmount,
    couponCodeError,
    couponCodeInput,
    setCouponCodeInput,
    setCouponCodeError,
    holdTicketConfirmFn,
    couponCodeApplyBtnFn,
    couponCodeLoader,
    unHoldTicketFn,
    payNowBtnLoader,
    checkboxAndWalletError,
    termsError,
    setTermsError,
    unHoldButtonLoader,
    removeCoupnCodeFn,
    setSelectPaymentMethod,
    selectPaymentMethod,
    setCheckboxAndWalletError,
    setIAcceptCheckBox,
    iAcceptCheckBox,
    step2PayNowBtnFn,
    holdButtonLoader,
    queryParams,
    downLoadTicketFn,
    bookingOtherData,
    formik,
    downloadTicketWithOutFareLoader,
    downloadTicketWithFareLoader,
    downloadTicketWithMarkupLoader,
    flightOnHoldCondition,
    setHasSubmitted,
    selectedAirArabiaBundle,
    onlinePaymentEnable,
    bookingStatus,
    displayPrice,
    renderMode = 'full',
    setTab2SubStep,
    resetSubmissionState
}) => {
    const [openMarkupPrice, setOpenMarkupPrice] = useState(false);
    const [showBundles, setshowBundles] = useState(false)
    const [seatDropdownOpen, setSeatDropdownOpen] = useState(false);
    // const [fareSummaryToggle, setFareSummaryToggle] = useState(false);
    //     const fareSummaryClick = () => {
    //     setFareSummaryToggle(!fareSummaryToggle);
    //   };
    const [markupPrice, setMarkupPrice] = useState(1);
    const [showHoldConfirmation, setShowHoldConfirmation] = useState(false);

    const { userAgentData, walletBalance } = useSelector((state) => state.userData);
    const flightHoldVendorList = userAgentData?.user_data?.flight_hold_vendor;
    const isHoldVendorAllowed = Array.isArray(flightHoldVendorList)
        ? flightHoldVendorList.includes(queryParams?.source)
        : true;
    let totalPrice = showDiscounts
        ? parseFloat(finalAmount)
        : parseFloat(finalAmount + parseFloat(extraChargePrice?.total || 0) + parseFloat(extraChargePrice?.seat || 0));
    const onineServicesFees = userAgentData?.onineServicesFees ?? 0;
    let onlineServiceFeeAmount = 0;
    if (selectPaymentMethod === 1) {
        onlineServiceFeeAmount = ((totalPrice * onineServicesFees) / 100)
        if (queryParams?.status === 'HOLD') {
            totalPrice = bookingOtherData?.totalPriceInfo?.couponData?.finalAmount ? parseFloat(bookingOtherData?.totalPriceInfo?.couponData?.finalAmount) : parseFloat(bookingOtherData?.totalPriceInfo?.totalFare)
            onlineServiceFeeAmount = ((totalPrice * onineServicesFees) / 100)
        }
    }

    // Function to get seat details for dropdown
    const getSeatDetails = () => {
        const seatDetails = [];
        if (formik?.values?.passgeners) {
            formik.values.passgeners.forEach((passenger, passengerIndex) => {
                if ((passenger?.SEAT && passenger.SEAT.length > 0) || (passenger?.SEATS && passenger.SEATS.length > 0)) {
                    (passenger.SEAT || passenger.SEATS).forEach((seat) => {
                        const existingSegment = seatDetails.find(item => item.segmentKey === seat.segmentKey);
                        if (existingSegment) {
                            existingSegment.passengers.push({
                                name: `${passenger.originalTitle || `Passenger ${passengerIndex + 1}`}`,
                                seatNumber: seat.seatNumber
                            });
                        } else {
                            seatDetails.push({
                                segmentKey: seat.segmentKey,
                                segmentName: seat.segmentKey,
                                passengers: [{
                                    name: `${passenger.originalTitle || `Passenger ${passengerIndex + 1}`}`,
                                    seatNumber: seat.seatNumber
                                }]
                            });
                        }
                    });
                }
            });
        }
        return seatDetails;
    };

    const handleHoldClick = () => {
        if (queryParams?.source === 'aljazeera') {
            setShowHoldConfirmation(true);
            return;
        }

        step2PayNowBtnFn(true);
    };


    return (
        <aside className={`hw-passenger--fareSummary fbd-sidebar ${renderMode === 'paymentOnly' ? 'fbd-pay-panel' : ''}`}>
            {(currentTab?.['1']?.active || currentTab?.['2']?.active) && renderMode !== 'paymentOnly' &&
                <>
                    {/* <div className={`hw-passenger--head ${fareSummaryToggle ? 'active' : ''}`}
  onClick={fareSummaryClick}> */}
                    <div className="hw-passenger--head">
                        <h2 className="mb-0 h4 hw-blue">Fare Summary</h2>
                        {/* <span className="hw-lg--onlyIcon">{fareSummaryToggle ?  <ChevronUpIcon/> : <ChevronDownIcon/>}</span> */}
                    </div>
                    <div className="hw-passenger--fareSummary__box">
                        <div className="hw-passenger--fareSummary__table">
                            <div className="hw-passenger--fareSummary__thead">
                                <span className="hw-black900 hw-fontBold">Base Fare</span>
                                <span
                                    className="hw-blue">{formatePriceFn(agentActiveCurrency, formatPrice(flightDataPriceObj?.baseFare), displayPrice)}</span>
                            </div>
                            {(queryParams?.source === 'aljazeera' && flightDataPriceObj?.bundleFee > 0) &&
                                <div className="hw-passenger--fareSummary__thead">
                                    <span className="hw-black900 hw-fontBold">Bundle Fee</span>
                                    <span
                                        className="hw-blue">{formatePriceFn(agentActiveCurrency, formatPrice(flightDataPriceObj?.bundleFee), displayPrice)}</span>
                                </div>
                            }
                            {(queryParams?.source === 'aljazeera' && flightDataPriceObj?.addOns > 0) &&
                                <div className="hw-passenger--fareSummary__thead">
                                    <span className="hw-black900 hw-fontBold">Extra Add Ons</span>
                                    <span
                                        className="hw-blue">{formatePriceFn(agentActiveCurrency, formatPrice(flightDataPriceObj?.addOns), displayPrice)}</span>
                                </div>
                            }
                            {((queryParams?.source === 'akasa-air' || queryParams?.source === 'aljazeera') && flightDataPriceObj?.infantFare) ?
                                <div className="hw-passenger--fareSummary__thead">
                                    <span className="hw-black900 hw-fontBold">Infant Fare</span>
                                    <span className="hw-blue">{formatePriceFn(agentActiveCurrency, formatPrice(flightDataPriceObj?.infantFare), displayPrice)}</span>
                                </div>
                                : ''}
                            {/*{queryParams?.source === 'air-arabia' && flightDataPriceObj?.bundleFee > 0 && (
                            <div className="hw-passenger--fareSummary__thead">
                                <span className="hw-black900 hw-fontBold">Bundle Fee</span>
                                <span className="hw-blue">{getActiveCode()} {formatPrice(flightDataPriceObj?.bundleFee)}</span>
                            </div>
                        )}*/}
                            <div className="hw-passenger--fareSummary__tbody">
                                <div onClick={() => {
                                    setShowTaxAndFees(!showTaxAndFees)
                                }} className="hw-passenger--fareSummary__tbodyRowMain">
                                    <div className="hw-passenger--fareSummary__tbodyTR">
                                        <span className="hw-black900 hw-fontBold">Taxes and Fees
                                            {flightDataPriceObj?.taxObj && Object?.keys(flightDataPriceObj?.taxObj)?.length ? showTaxAndFees ? <ChevronUpIcon /> : <ChevronDownIcon /> : ''}
                                        </span>
                                        <span className="hw-blue">{formatePriceFn(agentActiveCurrency, formatPrice(flightDataPriceObj?.taxes), displayPrice)}</span>
                                    </div>
                                </div>
                                {(showTaxAndFees && flightDataPriceObj?.taxObj) &&
                                    <div className="hw-passenger--fareSummary__tbodyRowInner">
                                        {Object.keys(flightDataPriceObj?.taxObj)?.length ? Object.keys(flightDataPriceObj?.taxObj)?.map((taxName) => {
                                            return (
                                                <>
                                                    <div className="hw-passenger--fareSummary__tbodyTR">
                                                        <span className="hw-fontWeight--500 hw-text14">{taxName}</span>
                                                        <span className="hw-fontWeight--500 flex-shrink--null hw-text14">{formatePriceFn(agentActiveCurrency, formatPrice(flightDataPriceObj?.taxObj?.[taxName]), displayPrice)}</span>
                                                    </div>
                                                </>
                                            )
                                        }) : ''}
                                    </div>
                                }
                                {showDiscounts &&
                                    <div className="hw-passenger--fareSummary__tbodyRowMain">
                                        <div className="hw-passenger--fareSummary__tbodyTR">
                                            <span
                                                className="hw-success hw-fontBold">{activeCouponCodeData?.discount_type === 'percentage' ? `${parseInt(activeCouponCodeData?.discount_value)}% Discount` : 'Coupon Discount'}</span>
                                            <span
                                                className="hw-success hw-fontBold">- {formatePriceFn(agentActiveCurrency, formatPrice(activeCouponCodeData?.totalDiscount || 0), displayPrice)}</span>
                                        </div>
                                    </div>
                                }
                                {/* Any vendor that can charge for seats must appear here: the seat
                                    cost is already inside the grand total below (and in the payment
                                    amount), so omitting a vendor shows an unexplained higher total. */}
                                {['air-arabia', 'travel-fusion', 'aljazeera'].includes(queryParams?.source) && Number(extraChargePrice?.seat || 0) !== 0 && <>
                                    <div onClick={() => {
                                        setSeatDropdownOpen(!seatDropdownOpen)
                                    }} className="hw-passenger--fareSummary__tbodyRowMain">
                                        <div className="hw-passenger--fareSummary__tbodyTR">
                                            <span
                                                className="hw-black hw-fontBold">Seat{seatDropdownOpen ?
                                                    <ChevronUpIcon /> : <ChevronDownIcon />}</span>
                                            <span
                                                className="hw-blue">{formatePriceFn(agentActiveCurrency, formatPrice(extraChargePrice?.seat), displayPrice)}</span>
                                        </div>
                                    </div>
                                    {seatDropdownOpen &&
                                        <div className="hw-passenger--fareSummary__tbodyRowInner">
                                            {getSeatDetails().map((segment, segmentIndex) => (
                                                <div key={`seat-segment-${segmentIndex}`}>
                                                    <div className="hw-passenger--fareSummary__tbodyTR">
                                                        <span className="hw-fontWeight--500 hw-text14">{segment.segmentName}</span>
                                                    </div>
                                                    {segment.passengers.map((passenger, passengerIndex) => (
                                                        <div key={`seat-passenger-${segmentIndex}-${passengerIndex}`} className="hw-passenger--fareSummary__tbodyTR">
                                                            <span className="hw-fontWeight--500 hw-text14" style={{ paddingLeft: '20px' }}>{passenger.name}</span>
                                                            <span className="hw-fontWeight--500 hw-text14">{passenger.seatNumber}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            ))}
                                        </div>
                                    }
                                </>
                                }

                                {extraChargePrice?.show && <>
                                    <div onClick={() => {
                                        setExtraChargePrice({ ...extraChargePrice, open: !extraChargePrice?.open })
                                    }} className="hw-passenger--fareSummary__tbodyRowMain">
                                        <div className="hw-passenger--fareSummary__tbodyTR">
                                            <span
                                                className="hw-black hw-fontBold">Baggage & Meals{extraChargePrice?.open ?
                                                    <ChevronUpIcon /> : <ChevronDownIcon />}</span>
                                            <span
                                                className="hw-blue">{formatePriceFn(agentActiveCurrency, formatPrice(extraChargePrice?.total), displayPrice)}</span>
                                        </div>
                                    </div>
                                    {extraChargePrice?.open &&
                                        <div className="hw-passenger--fareSummary__tbodyRowInner">
                                            <div className="hw-passenger--fareSummary__tbodyTR">
                                                <span className="hw-fontWeight--500 hw-text14">Meal</span>
                                                <span
                                                    className="hw-fontWeight--500 hw-text14">{formatePriceFn(agentActiveCurrency, formatPrice(extraChargePrice?.meal), displayPrice)}</span>
                                            </div>
                                            <div className="hw-passenger--fareSummary__tbodyTR">
                                                <span className="hw-fontWeight--500 hw-text14">Baggage</span>
                                                <span
                                                    className="hw-fontWeight--500 hw-text14">{formatePriceFn(agentActiveCurrency, formatPrice(extraChargePrice?.baggage), displayPrice)}</span>
                                            </div>
                                        </div>
                                    }
                                </>
                                }
                                {selectPaymentMethod === 1 &&
                                    <div className="hw-passenger--fareSummary__tbodyRowMain">
                                        <div className="hw-passenger--fareSummary__tbodyTR">
                                            <span className="hw-fontBold">Service fee</span>
                                            <span className="hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(onlineServiceFeeAmount), displayPrice)}</span>
                                        </div>
                                    </div>
                                }
                            </div>
                            {/* {flightDataPriceObj?.bundlePrice?.count > 0 && (
                            <>
                                <div
                                    onClick={() => setshowBundles(!showBundles)}
                                    className="hw-passenger--fareSummary__tbodyRowMain"
                                >
                                    <div className="hw-passenger--fareSummary__tbodyTR">
                                        <span className="hw-black hw-fontBold">
                                            Bundles{" "}
                                            {showBundles ? <ChevronUpIcon /> : <ChevronDownIcon />}
                                        </span>
                                        <span className="hw-black hw-fontBold">
                                            {formatPrice(flightDataPriceObj.bundlePrice.totalPrice)}{" "}
                                            {getActiveCode()}
                                        </span>
                                    </div>
                                </div>

                                {showBundles && flightDataPriceObj.bundlePrice?.count > 0 && (
                                    <div className="hw-passenger--fareSummary__tbodyRowInner">
                                        {Array.from({ length: flightDataPriceObj.bundlePrice.count }).map((_, i) => (
                                            <div key={i} className="hw-passenger--fareSummary__tbodyTR">
                                                <span className="hw-fontWeight--500 hw-text14">
                                                    {flightDataPriceObj.bundlePrice.bundleCode}
                                                </span>
                                                <span className="hw-fontWeight--500 hw-text14">
                                                    {formatPrice(flightDataPriceObj.bundlePrice.price)} {getActiveCode()}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </>
                        )} */}
                            {queryParams?.source === 'ndc-portal' &&
                                flightDataPriceObj?.bundlePrice &&
                                Object.keys(flightDataPriceObj.bundlePrice).length > 0 &&
                                !isNaN(flightDataPriceObj.bundlePrice.totalPrice) && (
                                    <div className="hw-passenger--fareSummary__thead">
                                        <span className="hw-black hw-fontBold">Bundle Fee</span>
                                        <span className="hw-black hw-fontBold">
                                            {formatePriceFn(agentActiveCurrency, formatPrice(flightDataPriceObj?.bundlePrice?.totalPrice), displayPrice)}
                                        </span>
                                    </div>
                                )}

                            <div className="hw-passenger--fareSummary__tfoot d-flex-column">
                                <div className="d-flex justify-between w-100">
                                    <span className="hw-black900 hw-fontBold">Total</span>
                                    <span className="hw-fontBold hw-primary flex-shrink--null">
                                        {showDiscounts ? formatePriceFn(agentActiveCurrency, formatPrice(parseFloat(finalAmount) + onlineServiceFeeAmount, true, true), displayPrice) : formatePriceFn(agentActiveCurrency, formatPrice(parseFloat(finalAmount) + parseFloat(extraChargePrice?.total || 0) + parseFloat(extraChargePrice?.seat || 0) + onlineServiceFeeAmount, true, true), displayPrice)}
                                    </span>
                                </div>
                                <AedChargeNote amount={showDiscounts ? (parseFloat(finalAmount) + onlineServiceFeeAmount) : (parseFloat(finalAmount) + parseFloat(extraChargePrice?.total || 0) + parseFloat(extraChargePrice?.seat || 0) + onlineServiceFeeAmount)} currencyCode={agentActiveCurrency} />
                            </div>
                        </div>
                        {currentTab?.['2']?.active && renderMode === 'summaryOnly' &&
                            <div className="hw-apply--coupen">
                                <div className="hw-apply--coupenField">
                                    <input
                                        style={{ border: (couponCodeError) ? "1px solid red" : "" }}
                                        className="hw-form--input"
                                        placeholder="Add Coupon Code"
                                        onChange={(event) => {
                                            setCouponCodeInput(event.target.value)
                                            setCouponCodeError('')
                                        }}
                                        type="text"
                                        value={couponCodeInput}
                                    />
                                    <button onClick={couponCodeApplyBtnFn}
                                        className="hw-btn hw-btn--primary">{couponCodeLoader ?
                                            <span style={{ minWidth: '2.8rem', minHeight: "2.8rem" }}
                                                className='hw-main--loaderCommon' /> : 'Apply'}</button>
                                </div>
                                {couponCodeError ? <span className="hw-input--error-search"
                                    style={{ position: "static" }}>{couponCodeError}</span> : ''}
                                {showDiscounts &&
                                    <div className="hw-apply--coupenAdded mt-4">
                                        <div className="d-flex hw-primary align-items-center hw-gapy4 flex-wrap">
                                            <DiscountIcon /><b className="ml-6">{activeCouponCodeData?.coupon_code}</b><b
                                                className="hw-black800">Applied</b></div>
                                        <button onClick={removeCoupnCodeFn}
                                            className="hw-link hw-link--icon flex-shrink--null">Remove<CloseIcon />
                                        </button>
                                    </div>
                                }
                            </div>
                        }
                        {currentTab?.['2']?.active && renderMode === 'summaryOnly' &&
                            <>
                                <div className="fbd-pay-actions">
                                    <button onClick={() => {
                                        if (totalPrice === 0 && selectPaymentMethod === 1) {
                                            setCheckboxAndWalletError("Online payment is not supported for this transaction.")
                                            return
                                        }
                                        step2PayNowBtnFn(false)
                                    }} disabled={payNowBtnLoader} className="hw-btn hw-btn--primary w-100">{payNowBtnLoader ?
                                        <span style={{ minWidth: '2.8rem', minHeight: "2.8rem" }}
                                            className='hw-main--loaderCommon' /> : 'Pay Now'}</button>
                                    {(queryParams?.source !== 'amadeus' && flightOnHoldCondition
                                        && isHoldVendorAllowed
                                        // aljazeera: Hold is only available when paying by Wallet
                                        && (queryParams?.source !== 'aljazeera' || selectPaymentMethod === 0)) ?
                                        <button
                                            onClick={handleHoldClick}
                                            className="hw-btn hw-btn--primaryOutline w-100"
                                            disabled={holdButtonLoader}
                                        >
                                            {holdButtonLoader ? (
                                                <span
                                                    style={{ minWidth: '2.8rem', minHeight: '2.8rem' }}
                                                    className="hw-main--loaderCommon"
                                                />
                                            ) : (
                                                'Hold'
                                            )}
                                        </button>
                                        : ''}
                                </div>
                                {checkboxAndWalletError ?
                                    <div className="fbd-pay-error">
                                        <span dangerouslySetInnerHTML={{ __html: checkboxAndWalletError }}
                                            className="hw-input--error-search" style={{ position: "static" }} />
                                    </div>
                                    : ''}
                            </>
                        }
                        {currentTab?.['1']?.active &&
                            <div className="mt-20">
                                <button type="button" onClick={() => {
                                    setHasSubmitted(true);
                                    formik.validateForm().then((errors) => {
                                        if (Object.keys(errors).length === 0) {
                                            formik.handleSubmit();
                                            window.scrollTo(0, 0)
                                        } else {
                                            // Open dropdowns for passengers with errors
                                            if (errors.passgeners && Array.isArray(errors.passgeners)) {
                                                errors.passgeners.forEach((passError, index) => {
                                                    if (passError && typeof passError === 'object' && Object.keys(passError).length > 0) {
                                                        formik.setFieldValue(`passgeners[${index}].open`, true);
                                                    }
                                                });
                                            }

                                            // Use a small timeout to allow the dropdowns to open and error messages to render
                                            setTimeout(() => {
                                                const errorElement = document.querySelector('.hw-p-error-cls');
                                                if (errorElement) {
                                                    errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                                }
                                            }, 100);
                                        }
                                    });
                                }} className="hw-btn hw-btn--primary w-100">Continue</button>
                            </div>
                        }
                        {currentTab?.['2']?.active && renderMode === 'full' &&
                            <div className="mt-20">
                                <button
                                    type="button"
                                    onClick={() => {
                                        if (setTab2SubStep) setTab2SubStep('payment');
                                        window.scrollTo(0, 0);
                                    }}
                                    className="hw-btn hw-btn--primary w-100"
                                >
                                    Continue to Payment
                                </button>
                            </div>
                        }
                    </div>
                </>
            }
            {(currentTab?.['2']?.active && renderMode === 'paymentOnly') &&
                <div className="fbd-pay-panel__box">
                  
                    <div className="hw-exchk--pay-wrap fbd-pay-methods">
                        <div className="hw-exchk--panelTitle hw-text18 fbd-select-pay-methods__title">Select Payment Method</div>
                        <div className="hw-exchk--payGrid fbd-pay-methods__grid">
                            <button
                                type="button"
                                onClick={() => {
                                    setSelectPaymentMethod(0)
                                }}
                                className={`hw-exchk--method fbd-pay-card ${selectPaymentMethod === 0 ? "is-selected fbd-pay-card--active" : ""}`}
                            >
                                <span className="hw-exchk--methodRadio fbd-pay-card__radio" />
                                <span className="hw-exchk--methodIco fbd-pay-card__icon"><WalletIcon /></span>
                                <span className="hw-exchk--methodBody fbd-pay-card__text">
                                    <span className="hw-exchk--methodName fbd-pay-card__title">Wallet</span>
                                    <span className="hw-exchk--methodDesc fbd-pay-card__sub">{(walletBalance !== null && walletBalance !== undefined) ? <>Balance {formatePriceFn(agentActiveCurrency, formatPrice(walletBalance, false, false, true), displayPrice)}</> : 'Pay from your agent wallet'}</span>
                                </span>
                            </button>
                            {onlinePaymentEnable && (
                                <button
                                    type="button"
                                    onClick={() => {
                                        setSelectPaymentMethod(1)
                                    }}
                                    className={`hw-exchk--method fbd-pay-card ${selectPaymentMethod === 1 ? "is-selected fbd-pay-card--active" : ""}`}
                                >
                                    <span className="hw-exchk--methodRadio fbd-pay-card__radio" />
                                    <span className="hw-exchk--methodIco fbd-pay-card__icon"><ComputerIcon /></span>
                                    <span className="hw-exchk--methodBody fbd-pay-card__text">
                                        <span className="hw-exchk--methodName fbd-pay-card__title">Online Payment</span>
                                        <span className="hw-exchk--methodDesc fbd-pay-card__sub">Visa, Mastercard, Amex</span>
                                    </span>
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="fbd-divider" />

                    <div className="fbd-booking-ref">
                        <div className="fbd-booking-ref__label">Booking Reference <span className="fbd-section__optional">(optional)</span></div>
                        {formik?.values?.bookingReferenceEnabled && (
                            <input
                                placeholder="Enter booking reference"
                                className="hw-form--input"
                                onChange={(e) => {
                                    resetSubmissionState && resetSubmissionState();
                                    formik.setFieldValue(
                                        "bookingReferenceNote",
                                        e.target.value
                                    );
                                }}
                                value={formik.values.bookingReferenceNote || ""}
                            />
                        )}
                    </div>

                    <div className="hw-term--condition">
                        <div className="hw-term--conditionInput">
    <input
        type="checkbox"
        id="input-accept"
        onChange={(e) => {
            if (e.target.checked) {
                setCheckboxAndWalletError("");
                setTermsError && setTermsError("");
            }
            setIAcceptCheckBox(e.target.checked);
        }}
        checked={iAcceptCheckBox}
        value={iAcceptCheckBox}
    />

    <label htmlFor="input-accept">
        By continuing you agree to our{" "}
        <a
            target="_blank"
            rel="noreferrer"
            href={`${process.env.wordpressApiEndPoint}terms-conditions`}
            className="hw-link--line"
        >
            Terms &amp; Conditions
        </a>{" "}
        and{" "}
        <a
            target="_blank"
            rel="noreferrer"
            href={`${process.env.wordpressApiEndPoint}privacy-policy`}
            className="hw-link--line"
        >
            Privacy Policy
        </a>
    </label>
</div>
                        {termsError ?
                            <span dangerouslySetInnerHTML={{ __html: termsError }}
                                className="hw-p-error-cls" style={{ position: "static" }} />
                            : ''}
                    </div>
                </div>
            }
            {currentTab?.['3']?.active &&
                <>
                    <div className="hw-passenger--fareSummary__box">
                        {(queryParams?.status === 'HOLD' || bookingStatus?.toLowerCase() === 'hold') ?
                            <div className="hw-after--bookingWidget tickets">
                                <div className="d-flex justify-between align-items-center hw-gapy10">
                                    <h4 className="h4 mb-0 hw-blue">Payment </h4><span className="hw-primary"><VoucherIcon /></span>
                                </div>
                                                                <div className="hw-exchk--pay-wrap fbd-pay-methods">
                                    <div className="hw-exchk--panelTitle hw-text18 fbd-select-pay-methods__title">Select Payment Method</div>
                                    <div className="hw-exchk--payGrid fbd-pay-methods__grid">
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setSelectPaymentMethod(0)
                                            }}
                                            className={`hw-exchk--method fbd-pay-card ${selectPaymentMethod === 0 ? "is-selected fbd-pay-card--active" : ""}`}
                                        >
                                            <span className="hw-exchk--methodRadio fbd-pay-card__radio" />
                                            <span className="hw-exchk--methodIco fbd-pay-card__icon"><WalletIcon /></span>
                                            <span className="hw-exchk--methodBody fbd-pay-card__text">
                                                <span className="hw-exchk--methodName fbd-pay-card__title">Wallet</span>
                                                <span className="hw-exchk--methodDesc fbd-pay-card__sub">{(walletBalance !== null && walletBalance !== undefined) ? <>Balance {formatePriceFn(agentActiveCurrency, formatPrice(walletBalance, false, false, true), displayPrice)}</> : 'Pay from your agent wallet'}</span>
                                            </span>
                                        </button>
                                        {onlinePaymentEnable && (
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setSelectPaymentMethod(1)
                                                }}
                                                className={`hw-exchk--method fbd-pay-card ${selectPaymentMethod === 1 ? "is-selected fbd-pay-card--active" : ""}`}
                                            >
                                                <span className="hw-exchk--methodRadio fbd-pay-card__radio" />
                                                <span className="hw-exchk--methodIco fbd-pay-card__icon"><ComputerIcon /></span>
                                                <span className="hw-exchk--methodBody fbd-pay-card__text">
                                                    <span className="hw-exchk--methodName fbd-pay-card__title">Online Payment</span>
                                                    <span className="hw-exchk--methodDesc fbd-pay-card__sub">Visa, Mastercard, Amex</span>
                                                </span>
                                            </button>
                                        )}
                                    </div>
                                </div>
                                <div className="hw-term--condition fbd-hold-actions">
                                    <div className="fbd-pay-actions">
                                        <button onClick={() => {
                                            setCheckboxAndWalletError('')
                                            if (totalPrice === 0 && selectPaymentMethod === 1) {
                                                setCheckboxAndWalletError("Online payment is not supported for this transaction.")
                                                return
                                            }
                                            holdTicketConfirmFn()
                                        }}
                                            className="hw-btn hw-btn--primary w-100" disabled={payNowBtnLoader} >{payNowBtnLoader ?
                                                <span style={{ minWidth: '2.8rem', minHeight: "2.8rem" }}
                                                    className='hw-main--loaderCommon' /> : 'Pay Now'}</button>
                                        {/*<button style={{display: "none"}} data-sc-key={process.env.SIMPLIFY_PUBLIC_KEY}
                                            data-color="#3264FF" data-name="test" data-description="flight"
                                            className="hw-btn hw-btn--primary w-100 online_book_now_btn">Pay Now
                                    </button>*/}
                                        {(queryParams?.source !== 'air-arabia' && queryParams?.source !== 'ndc-portal') ?
                                            <button onClick={() => {
                                                setCheckboxAndWalletError('')
                                                unHoldTicketFn()
                                            }}
                                                className="hw-btn hw-btn--primaryOutline w-100" disabled={unHoldButtonLoader}>{unHoldButtonLoader ?
                                                    <span style={{ minWidth: '2.8rem', minHeight: "2.8rem" }}
                                                        className='hw-main--loaderCommon' /> : 'UnHold'}</button>

                                            : ''}
                                    </div>
                                    {checkboxAndWalletError ?
                                        <div className="fbd-pay-error">
                                            <span dangerouslySetInnerHTML={{ __html: checkboxAndWalletError }}
                                                className="hw-input--error-search" style={{ position: "static" }} />
                                        </div>
                                        : ''}

                                </div>
                            </div> : ''
                        }
                        {queryParams?.status !== 'HOLD_RELEASE' ?
                            <div className="hw-after--bookingWidget tickets">
                                <div className="d-flex justify-between align-items-center hw-gapy10"><h4
                                    className="h4 mb-0 hw-blue">Download Tickets</h4>
                                </div>
                                <div className="fbd-ticket-row">
                                    <button disabled={!!downloadTicketWithFareLoader} onClick={() => {
                                        downLoadTicketFn(true)
                                    }} className="hw-btn hw-btn--primary w-100">{downloadTicketWithFareLoader ?
                                        <span style={{ minWidth: '2.8rem', minHeight: "2.8rem" }}
                                            className='hw-main--loaderCommon' /> : 'With Fare'} </button>
                                    <button disabled={!!downloadTicketWithOutFareLoader} onClick={() => {
                                        downLoadTicketFn(false)
                                    }} className="hw-btn hw-btn--primaryOutline w-100">{downloadTicketWithOutFareLoader ?
                                        <span style={{ minWidth: '2.8rem', minHeight: "2.8rem" }}
                                            className='hw-main--loaderCommon' /> : "Without Fare"} </button>
                                </div>
                                <div>
                                    <div className="hw-passenger--fareSummary__tbodyTR d-flex justify-end">
                                        <span onClick={() => { setOpenMarkupPrice(!openMarkupPrice) }} className="hw-black hw-fontBold d-flex align-item-center" style={{ cursor: "pointer" }}>Add Markup Price & Generate Ticket
                                            {openMarkupPrice ? <ChevronUpIcon /> : <ChevronDownIcon />}</span>
                                    </div>
                                    {openMarkupPrice ?
                                        <div className="fbd-ticket-row fbd-markup-row">
                                            <input
                                                type="number"
                                                value={markupPrice}
                                                placeholder="Enter Markup Price"
                                                className="hw-form--input markup-price"
                                                onChange={(event) => {
                                                    setMarkupPrice(event?.target?.value)
                                                }}
                                            />
                                            <button disabled={!!downloadTicketWithMarkupLoader} onClick={() => {
                                                downLoadTicketFn(true, openMarkupPrice, markupPrice)
                                            }} className="hw-btn hw-btn--primaryOutline">{downloadTicketWithMarkupLoader ?
                                                <span style={{ minWidth: '2.8rem', minHeight: "2.8rem" }}
                                                    className='hw-main--loaderCommon' /> : 'With Markup'} </button>
                                        </div>

                                        : null}
                                </div>

                            </div> : ''}
                        <div className="hw-after--bookingWidget price-backup">
                            <h4 className="h4 mb-0">Price Breakup</h4>
                            <div className="hw-passenger--fareSummary__thead">
                                <span className="hw-black hw-fontBold">Base Fare</span>
                                <span
                                    className="hw-black hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(bookingOtherData?.totalPriceInfo?.baseFare), displayPrice)}</span>
                            </div>
                            {((queryParams?.source === 'akasa-air' || queryParams?.source === 'aljazeera') && bookingOtherData?.totalPriceInfo?.infantFare) ?
                                <div className="hw-passenger--fareSummary__thead">
                                    <span className="hw-black hw-fontBold">Infant Fare</span>
                                    <span className="hw-black hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(bookingOtherData?.totalPriceInfo?.infantFare), displayPrice)}</span>
                                </div>
                                : ''}
                            {/* {queryParams?.source === 'air-arabia' && flightDataPriceObj?.bundleFee > 0 && (
                            <div className="hw-passenger--fareSummary__thead">
                                <span className="hw-black hw-fontBold">Bundle Fee</span>
                                <span className="hw-black hw-fontBold">{formatPrice(flightDataPriceObj?.bundleFee)} {getActiveCode()}</span>
                            </div>
                        )} */}
                            <div className="hw-passenger--fareSummary__tbody">
                                <div onClick={() => {
                                    setShowTaxAndFees(!showTaxAndFees)
                                }} className="hw-passenger--fareSummary__tbodyRowMain">
                                    <div className="hw-passenger--fareSummary__tbodyTR">
                                        <span

                                            className="hw-black900 hw-fontBold">Taxes and Fees {queryParams?.source !== 'amadeus' ? (bookingOtherData?.totalPriceInfo?.taxObj && Object.keys(bookingOtherData?.totalPriceInfo?.taxObj)?.length) ? (showTaxAndFees ?
                                                <ChevronUpIcon /> : <ChevronDownIcon />) : null : null}</span>
                                        <span
                                            className="hw-blue">{formatePriceFn(agentActiveCurrency, formatPrice(bookingOtherData?.totalPriceInfo?.taxes), displayPrice)}</span>
                                    </div>
                                </div>
                                {(showTaxAndFees && queryParams?.source !== 'amadeus') ?
                                    <div className="hw-passenger--fareSummary__tbodyRowInner">
                                        {(bookingOtherData?.totalPriceInfo?.taxObj && Object.keys(bookingOtherData?.totalPriceInfo?.taxObj)?.length) ? Object.keys(bookingOtherData?.totalPriceInfo?.taxObj)?.map((taxKeys) => {
                                            return (
                                                <div className="hw-passenger--fareSummary__tbodyTR">
                                                    <span className="hw-fontWeight--500 hw-text14">{taxKeys}</span>
                                                    <span
                                                        className="hw-fontWeight--500 flex-shrink--null hw-text14">{formatePriceFn(agentActiveCurrency, formatPrice(bookingOtherData?.totalPriceInfo?.taxObj?.[taxKeys]), displayPrice)}</span>
                                                </div>
                                            )
                                        }) : null}
                                    </div>
                                    : null
                                }
                            </div>

                            {
                                bookingOtherData?.totalPriceInfo?.bundleFee ?
                                    <div className="hw-passenger--fareSummary__thead">
                                        <span className="hw-black hw-fontBold">Bundle Fee</span>
                                        <span
                                            className="hw-black hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(bookingOtherData?.totalPriceInfo?.bundleFee), displayPrice)}</span>
                                    </div>
                                    : ''
                            }

                            {bookingOtherData?.totalPriceInfo?.specialServicePrice ?
                                <div className="hw-passenger--fareSummary__thead">
                                    <span className="hw-black hw-fontBold">Extra Service</span>
                                    <span
                                        className="hw-black hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(bookingOtherData?.totalPriceInfo?.specialServicePrice), displayPrice)}</span>
                                </div>
                                : ''
                            }

                            {queryParams?.status === 'HOLD' && selectPaymentMethod === 1 ?
                                <div className="hw-passenger--fareSummary__thead">
                                    <span className="hw-black hw-fontBold">Service Fee</span>
                                    <span className="hw-black hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(onlineServiceFeeAmount), displayPrice)}</span>
                                </div>

                                : ''}

                            {bookingOtherData?.totalPriceInfo?.onlineServiceFeeAmount ?
                                <div className="hw-passenger--fareSummary__thead">
                                    <span className="hw-black hw-fontBold">Service Fee</span>
                                    <span
                                        className="hw-black hw-fontBold">{formatePriceFn(agentActiveCurrency, formatPrice(bookingOtherData?.totalPriceInfo?.onlineServiceFeeAmount), displayPrice)}</span>
                                </div>
                                : ''
                            }

                            {bookingOtherData?.totalPriceInfo?.couponData?.totalDiscount ?
                                <div className="hw-passenger--fareSummary__thead">
                                    <span className="hw-success hw-fontBold">{bookingOtherData?.totalPriceInfo?.couponData?.discount_type === 'percentage' ? `${parseInt(bookingOtherData?.totalPriceInfo?.couponData?.discount_value)}% Discount` : 'Coupon Discount'}</span>
                                    <span className="hw-success hw-fontBold">- {formatePriceFn(agentActiveCurrency, formatPrice(bookingOtherData?.totalPriceInfo?.couponData?.totalDiscount || 0), displayPrice)}</span>
                                </div> : null}

                            {queryParams?.status === 'HOLD' && selectPaymentMethod === 1 ?
                                <div className="hw-passenger--fareSummary__tfoot">
                                    <span className="hw-black hw-fontBold">Total</span>
                                    <span className="hw-primary hw-fontBold">{(bookingOtherData?.totalPriceInfo?.couponData?.finalAmount !== null && bookingOtherData?.totalPriceInfo?.couponData?.finalAmount !== undefined) ? formatePriceFn(agentActiveCurrency, formatPrice(parseFloat(bookingOtherData?.totalPriceInfo?.couponData?.finalAmount) + (parseFloat(onlineServiceFeeAmount) || 0), true, true), displayPrice) : formatePriceFn(agentActiveCurrency, formatPrice(parseFloat(bookingOtherData?.totalPriceInfo?.totalFare) + (parseFloat(onlineServiceFeeAmount) || 0), true, true), displayPrice)}</span>
                                </div>
                                : <div className="hw-passenger--fareSummary__tfoot">
                                    <span className="hw-black hw-fontBold">Total</span>
                                    <span className="hw-primary hw-fontBold">{(bookingOtherData?.totalPriceInfo?.couponData?.finalAmount !== null && bookingOtherData?.totalPriceInfo?.couponData?.finalAmount !== undefined) ? formatePriceFn(agentActiveCurrency, formatPrice(parseFloat(bookingOtherData?.totalPriceInfo?.couponData?.finalAmount) + (parseFloat(bookingOtherData?.totalPriceInfo?.onlineServiceFeeAmount) || 0), true, true), displayPrice) : formatePriceFn(agentActiveCurrency, formatPrice(parseFloat(bookingOtherData?.totalPriceInfo?.totalFare) + (parseFloat(bookingOtherData?.totalPriceInfo?.onlineServiceFeeAmount) || 0), true, true), displayPrice)}</span>
                                </div>}
                        </div>
                    </div>

                </>
            }

            <CommonPopup
                show={showHoldConfirmation}
                setShow={setShowHoldConfirmation}
                title={<h4 className="mb-0 hw-blue">Confirm Hold Booking</h4>}
                modalClass="hw-modal-sm fbd-hold-dialog"
                bodyClass="fbd-modal-body"
            >
                <div className="fbd-hold-modal">
                    <div className="fbd-hold-note">
                        <span className="fbd-hold-note__icon">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                                <path d="M12 9v4m0 4h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </span>
                        <div className="fbd-hold-note__text">
                            A separate <strong>non-refundable hold fee of approximately AED 40 per passenger</strong> will be charged. <strong>This fee is separate from the flight booking amount.</strong>
                        </div>
                    </div>

                    <p className="fbd-hold-confirm">Are you sure you want to continue?</p>

                    <div className="fbd-hold-actions">
                        <button
                            className="hw-btn hw-btn--primaryOutline"
                            onClick={() => setShowHoldConfirmation(false)}
                            disabled={holdButtonLoader}
                        >
                            Cancel
                        </button>

                        <button
                            className="hw-btn hw-btn--primary"
                            disabled={holdButtonLoader}
                            onClick={() => {
                                setShowHoldConfirmation(false);
                                step2PayNowBtnFn(true);
                            }}
                        >
                            {holdButtonLoader ? (
                                <span
                                    style={{ minWidth: "2.8rem", minHeight: "2.8rem" }}
                                    className="hw-main--loaderCommon"
                                />
                            ) : (
                                "Pay & Hold Booking"
                            )}
                        </button>
                    </div>
                </div>
            </CommonPopup>
        </aside>
    );
}

export default BookingDetailsSideBarComponent;
